module.exports = __webpack_public_path__ + "static/media/aboutContent.aef2bd0d.txt";